import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { privateFetch } from '../../../utils/apiHelper';
import { Message } from 'primereact/message';
import Data from '../../../components/Backoffice/Display/Data';
import { check } from 'prettier';

function ManageResidencyAccount({
  isOpen,
  handleClose,
  createAccount,
  reasignAccount,
  loading,
  residency
}) {
  const [existingCustomUser, setExistingCustomUser] = useState(undefined);

  useEffect(() => {
    if (residency?.email) {
      checkExistingCustomUser();
    }
  }, [residency?.email]);

  const checkExistingCustomUser = async () => {
    await privateFetch('POST', `/cu/`, null, JSON.stringify({ email: residency.email })).then(
      (res) => {
        if (res && res.length > 0) {
          setExistingCustomUser(res[0]);
        } else {
          setExistingCustomUser(undefined);
        }
      }
    );
  };

  const onValidate = () => {
    existingCustomUser ? reasignAccount(existingCustomUser) : createAccount();
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`${existingCustomUser ? 'Ré-assigner le compte' : 'Créer le compte et envoyer un mail'}`}
        loading={loading}
        onClick={onValidate}
        severity="success"
      />
    </div>
  );

  const emailHelpMessage = () => {
    if (existingCustomUser) {
      return (
        <div className="flex flex-row gap-x-3">
          <i className="pi pi-exclamation-triangle text-2xl pt-2 text-custom-orange"></i>
          <p className="font-medium">
            {'Un compte associé à cet email '}
            <span className="text-custom-orange font-bold">existe déjà</span>
            {
              " et est lié à une résidence. Vous pouvez choisir de l'assigner dès maintenant à la résidence "
            }
            <span className="font-bold">{residency.label}</span>.
          </p>
        </div>
      );
    } else {
      return (
        <div className="flex flex-row gap-x-3">
          <i className="pi pi-check text-2xl pt-2 text-custom-green"></i>
          <p className="font-medium">
            {`Cet email n'est pas encore utilisé sur la plateforme, vous pouvez donc le créer et l'assigner à la résidence `}
            <span className="font-bold">{residency.label}</span>.
          </p>
        </div>
      );
    }
  };

  if (!residency) return null;

  return (
    <Sidebar
      style={{ width: 600 }}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`Créer un compte utilisateur`}</h3>
      }
      visible={isOpen}
      maskStyle={{ backgroundColor: '#00000080' }}
      onHide={() => handleClose()}
      position="right">
      <div className="sidebar-content-container">
        <div className="form-wrapper">
          <Data key="email" label={'Email de connexion'} value={residency.email} large />
          {emailHelpMessage()}
          <p>
            Un mail sera envoyé à l'adresse email avec les instructions pour choisir un nouveau mot
            de passe.
          </p>
        </div>

        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default ManageResidencyAccount;
